@if (_form) {
  <form [formGroup]="_form" (ngSubmit)="onSubmit()" class="form-horizontal">
    <!--title-->
    <h2 mat-dialog-title>
      <i class="material-icons m-r-10">file_copy</i>
      <span>{{model.modalTitle}}</span>
    </h2>
    <!--content-->
    <mat-dialog-content>
      @if (_fileType) {
        <p>Selezionare una configurazione aggiuntiva per questa tipologia di file</p>
      }
      @if (!model.fileTypeId && _fileTypeGroups) {
        <mat-form-field floatLabel="never">
          <mat-label class="required">Tipologia di documento</mat-label>
          <mat-select formControlName="fileTypeId">
            <mat-option>Seleziona...</mat-option>
            @for (_group of _fileTypeGroups; track _group) {
              <mat-optgroup [label]="_group.name">
                @for (_fileType of _group.fileTypes; track _fileType) {
                  <mat-option [value]="_fileType.id">
                    {{_fileType.label.replace('[[position]]','')}}
                  </mat-option>
                }
              </mat-optgroup>
            }
          </mat-select>
          @if (fileTypeId.errors?.required && fileTypeId.touched) {
            <mat-error>
              La tipologia di documento è obbligatoria
            </mat-error>
          }
        </mat-form-field>
      }
      <mat-form-field floatLabel="never">
        <mat-label class="required">Tipologia di persona</mat-label>
        <mat-select formControlName="personTypeId">
          <mat-option>Tutte</mat-option>
          @for (_personType of _personTypes; track _personType) {
            <mat-option [value]="_personType.id">
              {{_personType.name}}
            </mat-option>
          }
        </mat-select>
        <mat-hint>Lasciare vuoto per associare a tutte le tipologie di persona</mat-hint>
      </mat-form-field>
      <div class="m-t-20">
        <mat-form-field floatLabel="never">
          <mat-label class="required">Tipologia di beneficiario</mat-label>
          <mat-select formControlName="beneficiaryTypeId">
            <mat-option>Tutti</mat-option>
            @for (_beneficiaryType of _beneficiaryTypes; track _beneficiaryType) {
              <mat-option [value]="_beneficiaryType.id">
                {{_beneficiaryType.name}}
              </mat-option>
            }
          </mat-select>
          <mat-hint>Lasciare vuoto per associare a tutte le tipologie di beneficiario</mat-hint>
        </mat-form-field>
      </div>
      <div class="m-t-20">
        <mat-form-field floatLabel="never">
          <mat-label class="required">Titolo di possesso</mat-label>
          <mat-select formControlName="possessionTitleId">
            <mat-option>Tutti</mat-option>
            @for (_possessionTitle of _possessionTitles; track _possessionTitle) {
              <mat-option [value]="_possessionTitle.id">
                {{_possessionTitle.name}}
              </mat-option>
            }
          </mat-select>
          <mat-hint>Lasciare vuoto per associare a tutti i titoli di possesso</mat-hint>
        </mat-form-field>
      </div>
      <div class="m-t-20">
        @if (!model.fileTypeId) {
          <mat-form-field>
            <mat-label class="required">Posizione</mat-label>
            <input type="number" matInput formControlName="position" required />
            @if (position.errors?.required && position.touched) {
              <mat-error>
                La posizione è obbligatoria
              </mat-error>
            }
          </mat-form-field>
        }
      </div>
      <div class="m-t-20">
        <mat-checkbox formControlName="mandatory">
          Obbligatorio
        </mat-checkbox>
      </div>
    </mat-dialog-content>
    <!--actions-->
    <mat-dialog-actions>
      <button type="submit" mat-flat-button mat-ripple color="accent" [disabled]="!_form.valid">
        Conferma
      </button>
      <button type="button" mat-dialog-close mat-button mat-ripple>
        Annulla
      </button>
    </mat-dialog-actions>
  </form>
}
